runOnLoad "SuppressionLists", ["new","create","edit","update"], ->

  $listId      = $("#suppression_list_mailing_list_id")
  $listIdBag   = $listId.closest(".form-field")

  $scope = $("#suppression_list_suppression_scope")

  updateForScope = ->
    if $scope.val() == "mailing_list"
      $listIdBag.show()
    else
      UI.setSelectValue($listIdBag.find("select"), "")
      $listIdBag.hide()

  $scope.on("change", updateForScope)
  updateForScope()

runOnLoad "SuppressionLists", ["show"], ->

  $(document).on "change", ".select-suppressed-address-filter-type", ->

    $addressFilter    = $(@)
    suppressionListId = $addressFilter.data("suppression-list-id")
    addressType       = $addressFilter.val()
    window.location   = Routes.suppression_list_path(suppressionListId, address_type: addressType) + "#suppressed-addresses"
